// removed by extract-text-webpack-plugin
module.exports = {"thank-wrapper-A":"thank-wrapper-A","thank-icon":"thank-icon","thank-title":"thank-title","thank-desc":"thank-desc","thank-back-to-home":"thank-back-to-home","thank-link":"thank-link"};


//////////////////
// WEBPACK FOOTER
// ./pages/thank/style.scss
// module id = ./pages/thank/style.scss
// module chunks = 0